import React, { useCallback } from "react";
import BasflogoIcon from "../../assets/Icons/Logo.svg";
import "./header.scss";
import { SignOutButton } from "../Buttons/SignOutButton/SignOutButton";
import { useNavigate } from "react-router-dom";

const Header: React.FC = () => {
  const navigate = useNavigate();

  const handleLogoClick = useCallback(() => {
    navigate("/"); // Navigate to the home page when logo is clicked
  }, [navigate]);
  return (
    <div className="container-fluid headerStyle">
      <div className="row">
        <div className="col-md-3 col-sm-6">
          <button
            onClick={handleLogoClick}
            className="logoImage"
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
            aria-label="Go to home"
          >
            <img
              src={BasflogoIcon}
              width="160px"
              height="58px"
              alt="Logo"
            />
          </button>
        </div>
        <div className="col-md-3 col-sm-6 offset-md-6 profileBox">
          <SignOutButton />
        </div>
      </div>
    </div>
  );
};

export default Header;
